import apiClient from '../../../services/apiClient';

// Live TTS for reading AI answers aloud (POST /api/v1/tts/live). The backend
// may either stream audio/mpeg bytes back or return JSON { url } pointing at a
// freshly-synthesized clip. We normalize both into a playable object URL.

export interface LiveTtsResult {
  // A URL that can be assigned to <audio>.src. When the backend returns raw
  // bytes we create an object URL; the caller must revoke() it when done.
  url: string;
  // true when `url` is an object URL we created (so the caller revokes it).
  isObjectUrl: boolean;
}

export async function synthesizeLive(
  text: string,
  voice?: string
): Promise<LiveTtsResult> {
  // Ask for a blob; if the server actually replied with JSON, axios still hands
  // us a Blob whose type is application/json, which we parse below.
  const res = await apiClient.post(
    '/api/v1/tts/live',
    { text, voice },
    { responseType: 'blob' }
  );

  const blob = res.data as Blob;

  if (blob.type.includes('application/json')) {
    const parsed = JSON.parse(await blob.text()) as { url?: string };
    if (parsed.url) return { url: parsed.url, isObjectUrl: false };
    throw new Error('TTS response contained no audio URL');
  }

  return { url: URL.createObjectURL(blob), isObjectUrl: true };
}
